import React from "react";
import PropTypes from "prop-types";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./morethan95modal.scss";

const MoreThan95Modal = (props) => {
  const handleCloseClick = () => {
    if (typeof props.handleCloseButton === "function") {
      props.handleCloseButton();
    }
  };

  const handleContinueClick = () => {
    if (typeof props.handleContinue === "function") {
      props.handleContinue();
    }
  };

  return (
    <div className="mt-parent">
      <Row className="mb-3">
        <Col>
          <div className="mt-small-close">
            <button
              type="button"
              className="btn btn-link p-0"
              aria-label="Close modal"
              onClick={handleCloseClick}
            >
              <Icons iconname="close" variant="icon-sixteen-px" />
            </button>
          </div>
        </Col>
      </Row>
      <Row className="mt-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="mt-sub-title mb-5">
        <Col>
          <div>
            You are switching more than 95% of{" "}
            <span className="mt-text">
              {props.flaggedStrategyNames.length < 3
                ? props.flaggedStrategyNames.join(" and ")
                : `${props.flaggedStrategyNames
                    .slice(0, -1)
                    .join(", ")} and ${props.flaggedStrategyNames.at(-1)}`}
            </span>
            . To avoid market fluctuation issues, the system will process this
            as a full pot switch.
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="mt-group-button">
            <span className="mt-cancel-button">
              <Buttons
                name="Cancel"
                className="secondary"
                variantname="icon-sixteen-px"
                handleClick={handleCloseClick}
              ></Buttons>
            </span>
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              handleClick={handleContinueClick}
            ></Buttons>
          </div>
        </Col>
      </Row>
    </div>
  );
};

MoreThan95Modal.propTypes = {
  handleCloseButton: PropTypes.func,
  handleContinue: PropTypes.func,
  modalTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flaggedStrategyNames: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
};

MoreThan95Modal.defaultProps = {
  handleCloseButton: undefined,
  handleContinue: undefined,
  modalTitle: "",
  flaggedStrategyNames: [],
};

export default MoreThan95Modal;
